import React from "react";
import { useMultiSelectFilterContext } from "../MultiSelectFilter.context";
var MultiSelectFilterNoResult = function () {
    var id = useMultiSelectFilterContext().id;
    return (React.createElement("li", { id: id + "-no-result", className: "ssg-multi-select-filter__option-checkbox-option", tabIndex: 0 }, "Aucun r\u00E9sultat"));
};
export default MultiSelectFilterNoResult;
